var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "Checkmark",
    fill: "white",
    focusable: "false",
    role: "img",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: "vn-checkbox__span--icon css-3bfeue",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.7314453,17.0332031c-0.5078125,0-1.015625-0.1904297-1.4023438-0.5703125  l-3.3720703-3.3193359c-0.3935547-0.3867188-0.3994141-1.0200195-0.0117188-1.4135742  c0.3857422-0.3945312,1.0205078-0.3989258,1.4140625-0.0117188l3.3730469,3.3188477l7.9082031-7.7807617  c0.3925781-0.3876953,1.0273438-0.3823242,1.4140625,0.0117188c0.3876953,0.3935547,0.3818359,1.0268555-0.0117188,1.4140625  l-7.9082031,7.7807617C10.7480469,16.8427734,10.2392578,17.0332031,9.7314453,17.0332031z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.f052468ea123f774da1d190835c1aa1c.svg";
export { ForwardRef as ReactComponent };